import * as Bridge from "./NativeBridge";
const nativeBridge = new Bridge.NativeBridge();
export default nativeBridge;
export { Bridge };
export { nativeBridge };
